import { withStyles } from "@material-ui/core";
import { Rating } from "@material-ui/lab";
export const KvixRating = withStyles({
    root: {
        color: "#fecb00"
    },
    iconEmpty: {
        color: "transparent",
        stroke: "#fecb00",
        strokeWidth: "1.5px",
        transform: "scale(0.9)"
    },
    sizeSmall: {
        height: "20px",
        "& span": {
            paddingRight: 2.5
        }
    },
    sizeLarge: {
        "& span": {
            paddingRight: 8
        }
    }
})(Rating);
//# sourceMappingURL=Rating.js.map